export async function fetchPlaces(status = 'available') {
    const response = await fetch(`/api/places?status=${status}`);
    if (!response.ok) {
        throw new Error(`Failed to load places: ${response.status}`);
    }
    const data = (await response.json());
    return data.places;
}
